import Component from "@tunnel-components/@pages/incidents/home/component";
import * as React from "react";
import * as Utils from "@Cyclope-Utils/index";
import { connect } from "react-redux"; //
import {
  TunnelIncidentLoadedActionCreator,
  CheckNewIncidentsActionCreator,
  ImpactIsQualifiedActionCreator,
  ImpactIsReQualifiedActionCreator,
  ImpactFakeDeletedActionCreator,
  IncidentTypesLoadedActionCreator,
} from "@tunnel-store/index";
import * as Lodash from "lodash";
import * as Enums from "@tunnel-enums/index";
import * as Paths from "@tunnel-enums/index";
import * as i18next from "i18next";
import SetInterval from "set-interval";
// import * as Paths from '@tunnel-enums/index';

/**
 * @class Container : Composant à état
 * @description : composant “complexe” recevant des props et possédant
 * un état interne pour générer son rendu.
 * @extends { React.PureComponent }
 * @implements
 * @name  componentWillReceiveProps
 * @name  render
 * @infos "https://reactjs.org"
 */

class Container extends React.PureComponent<any, any> {
  /**
   * @constructor
   * @description :
   * Le Constructor est invoqué en premier.
   * Il reçoit en argument toutes les props initiales du composant
   * Le Constructor est aussi utilisé pour Binder les events Handler à l’instance.
   * @param { objet <any> } props
   */
  public constructor(props: any) {
    /**
     * @function
     * @description : Utilisé afin d'appeler ou d'accéder
     * à des fonctions définies sur l'objet parent.
     */
    super(props);
    /**
     * @namespace
     * @property { object }       state
     * @property { array }        state.active
     * ...
     */
    this.state = {
      actionFalseAlarmPatterns: [],
      actionFalseAlarmPatternsError: [],
      actionLoader: [],
      actionSeaPatterns: [],
      incidentOngletParameter: "",
      identifiantActifSea: { id: 0 },
      incidentDataAll: [],
      incidentData: [],
      itemPerRow: 3,
      currentPageNumbers: 1, // nouvelle pagination
      ongletActive: [true, false, false, false, false, false, false],
      totalElements: 1,
      totalRowElements: 1,
      itemsPerPage: 12, // 20000 incidents => 28s // 5000 incidents => 10s // 3000 incidents => 8s // 50 incidents => 6s
      errorserver: false,
      audioBoolean: true,
    };
    /**
     * @description : Empêcher l'exécution des méthodes à chaque initialisation
     * des composants ; "seulement quand un event est exécuté"
     */
    // nouvelle pagination
    this.onUpdateCurrentPageNumber = this.onUpdateCurrentPageNumber.bind(this);
    // nombre d'incidents par ligne
    this.onChangeItemPerRow = this.onChangeItemPerRow.bind(this);
    //
    this.onClickOnglet = this.onClickOnglet.bind(this);

    // Mise à jour de la valeur du ScrollTop
    this.onUpdateScrollTop = this.onUpdateScrollTop.bind(this);
    //
    this.onDeleteFakeIncident = this.onDeleteFakeIncident.bind(this);
    this.onQualified = this.onQualified.bind(this);
    this.onSubmitPatterns = this.onSubmitPatterns.bind(this);
    this.onChangePatterns = this.onChangePatterns.bind(this);
    this.onSearchValue = this.onSearchValue.bind(this);
    this.onCloseSeaPatterns = this.onCloseSeaPatterns.bind(this);
    this.onSubmitSeaPatterns = this.onSubmitSeaPatterns.bind(this);

    // ferméture du pattern
    this.onClosePattern = this.onClosePattern.bind(this);

    //

    //
    this.rediRectToo = this.rediRectToo.bind(this);
  }

  /**
   * MAJ des onglets
   * @public
   * @method
   * @name onCheckEvent
   * @param { void }
   * @return { void }
   * @infos "https://reactjs.org"
   */
  public onCheckEvent = (): void => {
    const visProp = Utils.getHiddenProp();

    if (document[visProp]) {
      SetInterval.clear("event");
    } else {
      {
        /** Empêcher la mutation du state */
      }
      const callback = () => {
        if (!Lodash.isUndefined(this.state.totalElements)) {
          this.props
            .CheckNewIncidentsActionCreator(this.state.totalElements)
            .then(() => {
              if (!Lodash.isUndefined(this.props.checkIncidents)) {
                if (this.props.checkIncidents) {
                  this.onCheckAction(
                    this.state.currentPageNumbers - 1,
                    this.state.itemsPerPage,
                    this.state.incidentOngletParameter
                  );
                }
              }
            });
        }
      };
      SetInterval.start(callback, 1000, "event");
    }
  };
  /**
   * MAJ des données relatifs aux incidents
   * @public
   * @method onCheckAction
   * @param { number } current
   * @param { number } items
   * @infos "https://reactjs.org"
   */
  public onCheckAction = (
    current: number,
    items: number,
    incidentOngletParameter: string
  ) => {
    this.props
      .TunnelIncidentLoadedActionCreator(
        current,
        items,
        incidentOngletParameter
      )
      .then(() => {
        if (!Lodash.isUndefined(this.props.error)) {
          this.setState({ errorserver: true });
        }
      })
      .then(() => this.setState({ loading: false }));
  };
  /**
   * envoie vers le SEA
   * @public
   * @method onSubmitSeaPatterns
   * @param { any } event
   * @param { number } id
   * @param { number } index
   * @infos "https://reactjs.org"
   */
  public onSubmitSeaPatterns = (id: number, index: number, sea: any) => (
    event: any
  ) => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    /**
     * @description :
     * @const
     * @name actionSeaPatterns
     * @type  boolean[]
     */
    const actionSeaPatterns: boolean[] = [];
    /**
     * @description :
     * @const
     * @name actionLoader
     * @type  boolean[]
     */
    const actionLoader: boolean[] = [];

    for (
      let i = 0;
      i <= Math.ceil(this.state.actionFalseAlarmPatterns.length);
      i++
    ) {
      actionSeaPatterns.push(false); // remplir le tableau
      actionLoader.push(false); // remplir le tableau
    }

    actionSeaPatterns[index] = false;
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({ actionSeaPatterns }));

    actionLoader[index] = true;
    {
      /** Empêcher la mutation du state */
    }

    this.setState((state: any) => ({
      actionLoader,
      identifiantActifSea: { id: 0 },
    }));
    {
      /** Rafraichir la page */
    }
    this.props.TunnelIncidentLoadedActionCreator(
      this.state.currentPageNumbers - 1,
      this.state.itemsPerPage,
      this.state.incidentOngletParameter
    );

    // this.onCheckEvent(); // reactiver le pulling
    this.allCalleverySeconde(); //  event :  visibilitychange
  };
  /**
   * ne pas envoyer vers le SEA
   * @public
   * @method onCloseSeaPatterns
   * @param { any } event
   * @param { number } index
   * @infos "https://reactjs.org"
   */
  public onCloseSeaPatterns = (index: number) => (event: any) => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    /**
     * @description :
     * @const
     * @name actionSeaPatterns
     * @type  boolean[]
     */
    const actionSeaPatterns: boolean[] = [];
    {
      /** boucle */
    }
    for (
      let i = 0;
      i <= Math.ceil(this.state.actionFalseAlarmPatterns.length);
      i++
    ) {
      actionSeaPatterns.push(false); // remplir le tableau
    }

    actionSeaPatterns[index] = false;
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({ actionSeaPatterns }));

    this.allCalleverySeconde(); //  event :  visibilitychange
  };
  /**
   * fermeture du pattern
   * @public
   * @method onClosePattern
   * @param { any } event
   * @param { number } index
   * @infos "https://reactjs.org"
   */
  public onClosePattern = (index: number) => (event: any) => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    /**
     * @description :
     * @const
     * @name actionFalseAlarmPatternsError
     * @type  boolean[]
     */
    const actionFalseAlarmPatternsError: boolean[] = [];
    /**
     * @description :
     * @const
     * @name actionFalseAlarmPatterns
     * @type  boolean[]
     */
    const actionFalseAlarmPatterns: boolean[] = [];

    for (
      let i = 0;
      i <= Math.ceil(this.state.actionFalseAlarmPatternsError);
      i++
    ) {
      actionFalseAlarmPatternsError.push(false); // remplir le tableau
      actionFalseAlarmPatterns.push(false); // remplir le tableau
    }
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({
      actionFalseAlarmPatternsError,
      actionFalseAlarmPatterns,
    }));

    this.allCalleverySeconde(); //  event :  visibilitychange
  };

  /**
   * Changement des etats des inputs
   * @method onSearchValue
   * @param { any }  event
   * @infos "https://reactdatepicker.com/"
   */
  public onSearchValue = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    /**
     * @description :
     * @const
     * @name actionFalseAlarmPatternsError
     * @type  boolean[]
     */
    const actionFalseAlarmPatternsError: boolean[] = [];

    for (
      let i = 0;
      i <= Math.ceil(this.state.actionFalseAlarmPatternsError);
      i++
    ) {
      actionFalseAlarmPatternsError.push(false); // remplir le tableau
    }
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({ actionFalseAlarmPatternsError }));
    {
      /** vérification de l'existence de l'élement  */
    }
    if (!Lodash.isUndefined(this.props.itemslabelIncident)) {
      /**
       * @constant
       * @name selectedOptionsIncident
       * @type any[]
       */
      const selectedOptionsIncident: any[] = this.onSortDynamic(
        Utils.transformObjectToArray(this.props.itemslabelIncident)
      ).filter(
        (elem: any) =>
          i18next
            .t(`${elem.label}`)
            .toLowerCase()
            .indexOf(event.target.value.toLowerCase()) !== -1
      );

      {
        /** Empêcher la mutation du state */
      }
      this.setState({
        patternfalseAlarm: "eudes",
        selectedOptionsIncident,
        selectedValueSearch: event.target.value.trim(),
      });
    }
  };
  /**
   * Manipulation  des inputs
   * @public
   * @method onChangePatterns
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onChangePatterns(value: any) {
    /**
     * @description :
     * @const
     * @name actionFalseAlarmPatternsError
     * @type  boolean[]
     */
    const actionFalseAlarmPatternsError: boolean[] = [];
    {
      /** boucle */
    }
    for (
      let i = 0;
      i <= Math.ceil(this.state.actionFalseAlarmPatternsError);
      i++
    ) {
      actionFalseAlarmPatternsError.push(false); // remplir le tableau
    }
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({ actionFalseAlarmPatternsError }));
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({
      //  [event.target.name]: event.target.value,
      patternfalseAlarm: value,
    }));
  }
  /**
   * valider le type d'incidents
   * @public
   * @method onSubmitPatterns
   * @param { any } event
   * @param { number } id
   * @param { number } index
   * @param { any } sea
   * @infos "https://reactjs.org"
   */
  public onSubmitPatterns = (id: number, index: number, sea: any) => (
    event: any
  ) => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    /**
     * @description : retourne un objet ( utilisateur )
     * @const
     * @name User
     * @type { any  }
     */
    const User: any = Utils.createdUserRoles();
    /**
     * @constant
     * @description :
     * @name  authorisation
     * @types boolean
     */
    const authorisation: boolean = Utils.simpleAuthorizationIsAllowed(User, [
      Enums.AuthorizationRightsEnums.AFFICHAGESAE,
    ]);
    {
      /** vérification de l'existence de l'élement  */
    }
    if (
      !Lodash.isUndefined(this.state.patternfalseAlarm) &&
      !Lodash.isEqual(this.state.patternfalseAlarm, "eudes")
    ) {
      /**
       * @constant
       * @name actionFalseAlarmPatterns
       * @type boolean[]
       */
      const actionFalseAlarmPatterns: boolean[] = [];
      /**
       * @constant
       * @name actionSeaPatterns
       * @type boolean[]
       */
      const actionSeaPatterns: boolean[] = [];
      /**
       * @constant
       * @name actionFalseAlarmPatternsError
       * @type boolean[]
       */
      const actionFalseAlarmPatternsError: boolean[] = [];

      for (
        let i = 0;
        i <= Math.ceil(this.state.actionFalseAlarmPatterns.length);
        i++
      ) {
        actionFalseAlarmPatterns.push(false); // remplir le tableau ;
        actionSeaPatterns.push(false); // remplir le tableau ;
        actionFalseAlarmPatternsError.push(false); // remplir le tableau ;
      }

      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any) => ({
        actionFalseAlarmPatterns,
        actionFalseAlarmPatternsError,
      }));
      /**
       *  Si l'utilisateur n'a pas des authorisations
       *  on active le chargement de la page avec  this.setState({ loading: true})
       *  on fait appel à l'action  "this.props.ImpactIsReQualifiedActionCreator(id, -1,Number(this.state.patternfalseAlarm))"
       *  on recharge la page avec  l'action "this.props.TunnelIncidentLoadedActionCreator(this.state.currentPageNumbers-1,this.state.itemsPerPage)"
       *  on supprime le chargement avec setState({ loading: false})
       *  et on détruit la clé avec  "localStorage.removeItem("identifiantActifSea")";
       *  if( authorisation){}
       */

      if (authorisation && !Lodash.isUndefined(sea)) {
        // existance du sea

        actionSeaPatterns[index] = true;

        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any) => ({ actionSeaPatterns }));
        this.props
          .ImpactIsReQualifiedActionCreator(
            id,
            -1,
            Number(this.state.patternfalseAlarm)
          )
          .then(() =>
            this.setState((state: any) => ({ patternfalseAlarm: "eudes" }))
          );
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any) => ({ identifiantActifSea: { id } }));
      } else {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any) => ({ actionSeaPatterns }));

        this.props
          .ImpactIsReQualifiedActionCreator(
            id,
            -1,
            Number(this.state.patternfalseAlarm)
          )
          .then(() =>
            this.setState((state: any) => ({ patternfalseAlarm: "eudes" }))
          ) // MAJ la valeur de l'input
          .then(() =>
            this.props.TunnelIncidentLoadedActionCreator(
              this.state.currentPageNumbers - 1,
              this.state.itemsPerPage,
              this.state.incidentOngletParameter
            )
          );

        // this.onCheckEvent(); // reactiver le pulling
        this.allCalleverySeconde(); //  event :  visibilitychange
      }
    } else {
      /**
       * @constant
       * @name actionFalseAlarmPatternsError
       * @type boolean[]
       */
      const actionFalseAlarmPatternsError: boolean[] = [];

      {
        /** boucle */
      }
      for (
        let i = 0;
        i <= Math.ceil(this.state.actionFalseAlarmPatterns.length);
        i++
      ) {
        actionFalseAlarmPatternsError.push(false); // remplir le tableau
      }

      actionFalseAlarmPatternsError[index] = true;
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any) => ({ actionFalseAlarmPatternsError }));
    }
  };
  /**
   * Qualification des incidents
   * @public
   * @method onQualified
   * @param { any } event
   * @param { number } id
   * @param { number } isQualify
   * @param { number } index
   * @infos "https://reactjs.org"
   */
  public onQualified = (id: number, isQualify: number, index: number) => (
    event: any
  ) => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    /**
     * @constant
     * @name actionLoader
     * @type boolean[]
     */
    const actionLoader: boolean[] = [];

    for (let i = 0; i <= Math.ceil(this.state.actionLoader.length); i++) {
      actionLoader.push(false); // remplir le tableau
    }
    {
      /** boucle */
    }
    if (isQualify === -1) {
      /**
       * @constant
       * @name actionFalseAlarmPatterns
       * @type boolean[]
       */
      const actionFalseAlarmPatterns: boolean[] = [];
      {
        /** boucle */
      }
      for (
        let i = 0;
        i <= Math.ceil(this.state.actionFalseAlarmPatterns.length);
        i++
      ) {
        actionFalseAlarmPatterns.push(false); // remplir le tableau
      }

      actionFalseAlarmPatterns[index] = true;
      {
        /** */
      }
      this.setState((state: any) => ({ actionFalseAlarmPatterns }));

      this.removeEvent(); // remove event :
    } else {
      actionLoader[index] = true;
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any) => ({ actionLoader }));

      this.props.ImpactIsQualifiedActionCreator(id, isQualify).then(() => {
        this.props
          .TunnelIncidentLoadedActionCreator(
            this.state.currentPageNumbers - 1,
            this.state.itemsPerPage,
            this.state.incidentOngletParameter
          )
          .then(() => this.allCalleverySeconde());
      });
    }
  };
  /**
   * Supression des simulations d'incidents
   * @public
   * @method onDeleteFakeIncident
   * @param { any } event
   * @param { number } id
   * @param { number } index
   * @infos "https://reactjs.org"
   */
  public onDeleteFakeIncident = (id: number, index: number) => (event: any) => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    /**
     * @constant
     * @name actionLoader
     * @type boolean[]
     */
    const actionLoader: boolean[] = [];
    {
      /** boucle */
    }
    for (let i = 0; i <= Math.ceil(this.state.actionLoader.length); i++) {
      actionLoader.push(false);
    }

    actionLoader[index] = true;
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({ actionLoader }));
    // Action Creator
    this.props
      .ImpactFakeDeletedActionCreator(id)
      .then(() =>
        this.props.TunnelIncidentLoadedActionCreator(
          this.state.currentPageNumbers - 1,
          this.state.itemsPerPage,
          this.state.incidentOngletParameter
        )
      );
  };
  /**
   * MAJ des onglets
   * @public
   * @method
   * @name onClickOnglet
   * @param { any } event
   * @param { any } index
   * @infos "https://reactjs.org"
   */
  public onClickOnglet = (param: string, index: number) => (
    event: any
  ): void => {
    const ongletActive: any[] = [];

    for (let i = 1; i <= Math.ceil(this.state.ongletActive.length); i++) {
      ongletActive.push(false);
    }
    ongletActive[index] = true;

    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({ ongletActive }));

    switch (param) {
      case "Tube sud":
        this.setState((state: any) => ({
          incidentOngletParameter: "&sections=Tube Sud",
        }));
        break;
      case "Tube nord":
        this.setState((state: any) => ({
          incidentOngletParameter: "&sections=Tube nord",
        }));
        break;
      case "Trémie Léon Bourgeois":
        this.setState((state: any) => ({
          incidentOngletParameter: "&sections=Trémie Léon Bourgeois",
        }));
        break;
      case "À qualifier":
        this.setState((state: any) => ({
          incidentOngletParameter: "&aQualified=true",
        }));
        break;
      case "Avérés":
        this.setState((state: any) => ({
          incidentOngletParameter: "&truePositive=true",
        }));
        break;
      case "Fausses alarmes":
        this.setState((state: any) => ({
          incidentOngletParameter: "&falsePositive=true",
        }));
        break;

      default:
        this.setState((state: any) => ({ incidentOngletParameter: "" }));
        break;
    }
  };
  /**
   * @method onChangeItemPerRow
   * @description: MAJ du nombre de column
   * @param { number } event
   * @infos "https://reactjs.org"
   */
  public onChangeItemPerRow = (target: any) =>
    this.setState((state: any) => ({
      errorserver: false,
      itemPerRow: Number(target),
    }));
  /**
   * @method onUpdateCurrentPageNumber
   * @description: MAJ de la page courante
   * @param { any } target
   * @infos "https://reactjs.org"
   */
  public onUpdateCurrentPageNumber = (target: any) =>
    this.setState((state: any) => ({
      errorserver: false,
      currentPageNumbers: Number(target),
    }));
  /**
   * @method onUpdateScrollTop
   * @description: MAJ du scrollIncident
   * @param { any } target
   * @infos "https://reactjs.org"
   */
  public onUpdateScrollTop = (target: any) =>
    this.setState((state: any) => ({
      errorserver: false,
      scrollIncident: Number(target),
    }));

  /**
   * MAJ des onglets
   * @public
   * @method
   * @name removeEvent
   * @param { void }
   * @return { void }
   * @infos "https://reactjs.org"
   */
  public removeEvent = (): void => {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({ countInterval: null }));
    /**
     * @constant
     * @name visProp
     * @type any
     */
    const visProp: any = Utils.getHiddenProp();
    /**
     * @constant
     * @name evtName
     * @type any
     */
    const evtName: any = visProp.replace(/[H|h]idden/, "") + "visibilitychange";

    {
      /** suppression de l'event */
    }
    document.removeEventListener(evtName, this.onCheckEvent);
  };

  // this.props.history.push(Paths.PathsNamesEnums.TUNNELWATCH)
  /**
   * MAJ des onglets
   * @public
   * @method
   * @name removeEventBip
   * @param { void }
   * @infos "https://reactjs.org"   `${Paths.PathsNamesEnums.TUNNELWATCHINCIDENTFILE}${item.id}`
   */
  public rediRectToo = (Id: number) => (event: any): void => {
    this.props.history.push(
      `${Paths.PathsNamesEnums.TUNNELWATCHINCIDENTFILE}${Id}`
    );
    window.location.reload(false);
  };

  /**
   * MAJ des onglets
   * @public
   * @method
   * @name allCalleverySeconde
   * @param { void }
   * @return { void }
   * @infos "https://reactjs.org"
   */
  public allCalleverySeconde = (): void => {
    {
      /** Handle page visibility change */
    }

    if (document.addEventListener) {
      /**
       * @constant
       * @name visProp
       * @type any
       */
      const visProp: any = Utils.getHiddenProp();
      /**
       * @constant
       * @name evtName
       * @type any
       */
      const evtName: any =
        visProp.replace(/[H|h]idden/, "") + "visibilitychange";

      document.addEventListener(evtName, this.onCheckEvent, false);
    }

    {
      /** initialisation de la requetes: vérification des incidents */
    }
    this.onCheckEvent();
  };
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name
   * @description : il est appelée. Une fois le rendu fait,
   * C’est le moment idéal pour aller chercher
   * les références directes des éléments du DOM
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentDidMount() {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ loading: true }));

    {
      /** Action creator */
    }
    this.props.IncidentTypesLoadedActionCreator(); // Chargement de la liste des incidents....

    {
      /** Action creator */
    }
    this.props
      .TunnelIncidentLoadedActionCreator(
        this.state.currentPageNumbers - 1,
        this.state.itemsPerPage,
        this.state.incidentOngletParameter
      )
      .then(() => this.setState((state: any): any => ({ loading: false })));

    this.allCalleverySeconde(); // requete toutes les secondes
  }

  /**
   * Triage dans un tableau par ordre
   * @method onSortDynamic
   * @param { any[] }  Elem
   * @return { any []}
   * @infos "https://reactjs.org"
   */
  public onSortDynamic = (Elem: any): any => {
    {
      /** vérification de l'existence de l'élement  */
    }
    if (Lodash.isArray(Elem)) {
      return Elem.sort((a: any, b: any) =>
        a.orderView > b.orderView ? 1 : b.orderView > a.orderView ? -1 : 0
      );
    }
  };
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentDidUpdate
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } prevProps
   * @param { any } prevState
   * @infos "https://reactjs.org"
   */
  public componentDidUpdate(prevProps: any, prevState: any) {
    {
      /** vérification de l'existence de l'élement  */
    }
    if (prevState.currentPageNumbers !== this.state.currentPageNumbers) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({ loading: true }));
      {
        /** Action creator */
      }
      this.props
        .TunnelIncidentLoadedActionCreator(
          this.state.currentPageNumbers - 1,
          this.state.itemsPerPage,
          this.state.incidentOngletParameter
        )
        .then(() => this.setState((state: any): any => ({ loading: false })));
    } else if (
      prevState.incidentOngletParameter !== this.state.incidentOngletParameter
    ) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({ loading: true }));
      {
        /** Action creator */
      }
      this.props
        .TunnelIncidentLoadedActionCreator(
          0,
          this.state.itemsPerPage,
          this.state.incidentOngletParameter
        )
        .then(() =>
          this.setState((state: any): any => ({ currentPageNumbers: 1 }))
        )
        .then(() => this.setState((state: any): any => ({ loading: false })));
    } else if (prevState.itemPerRow !== this.state.itemPerRow) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        itemPerRow: this.state.itemPerRow,
      }));
    } else if (prevState.scrollIncident !== this.state.scrollIncident) {
      if (
        this.state.actionFalseAlarmPatterns.every(
          (action: any) => action === false
        ) ||
        this.state.actionFalseAlarmPatterns.every(
          (action: any) => action === false
        )
      ) {
        this.removeEvent(); // remove event :  visibilitychange
        this.allCalleverySeconde(); //  event :  visibilitychange
      } else {
        this.removeEvent(); // remove event :  visibilitychange
      }
    } else if (prevState.incidentData !== this.state.incidentData) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        incidentData: this.state.incidentData,
      }));
    }
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillReceiveProps
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } nextProps
   * @infos "https://reactjs.org"
   */
  public componentWillReceiveProps(nextProps: any) {
    {
      /** comparaison */
    }
    if (nextProps.error !== this.props.error) {
      {
        /** vérification de l'existance */
      }
      if (!Lodash.isUndefined(nextProps.error)) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({ errorserver: true }));
      }
    } else if (nextProps.data !== this.props.data) {
      {
        /** vérification de l'existence de l'élement  */
      }
      if (
        !Lodash.isUndefined(nextProps.data) &&
        !Lodash.isUndefined(nextProps.data.content)
      ) {
        /**
         * @constant
         * @name actionLoader
         * @type boolean[]
         */
        const actionLoader: boolean[] = [];
        /**
         * @constant
         * @name actionFalseAlarmPatterns
         * @type boolean[]
         */
        const actionFalseAlarmPatterns: boolean[] = [];
        /**
         * @constant
         * @name actionSeaPatterns
         * @type boolean[]
         */
        const actionSeaPatterns: boolean[] = [];
        /**
         * @constant
         * @name actionFalseAlarmPatternsError
         * @type boolean[]
         */
        const actionFalseAlarmPatternsError: boolean[] = [];
        {
          /** boucle  */
        }
        for (let i = 0; i <= Math.ceil(nextProps.data.content.length); i++) {
          actionLoader.push(false); // remplir le tableau
          actionFalseAlarmPatterns.push(false); // remplir le tableau
          actionSeaPatterns.push(false); // remplir le tableau
          actionFalseAlarmPatternsError.push(false); // remplir le tableau
        }
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({
          actionLoader,
          actionSeaPatterns,
          actionFalseAlarmPatternsError,
          actionFalseAlarmPatterns,
          incidentData: Utils.transformObjectToArray(nextProps.data.content),
          // incidentDataAll:  Utils.transformObjectToArray(nextProps.data.content),
          // incidentData: [],
          totalElements: nextProps.data.totalElements,
          totalRowElements: nextProps.data.content.length,
        }));
      }
    } else if (nextProps.itemslabelIncident !== this.props.itemslabelIncident) {
      {
        /** vérification de l'existence de l'élement  */
      }
      //  if(!Lodash.isUndefined(nextProps.itemslabelIncident)){ this.setState((state: any):any =>({  selectedOptionsIncident: this.onSortDynamic(Utils.transformObjectToArray(nextProps.itemslabelIncident)) })) }
      if (!Lodash.isUndefined(nextProps.itemslabelIncident)) {
        this.setState((state: any): any => ({
          selectedOptionsIncident: this.onSortDynamic(
            Utils.transformObjectToArray(nextProps.itemslabelIncident)
          ),
        }));
      }
    }
  }
  /**
   * Cycle de vie React : componentWillUnmount
   * @public
   * @method componentWillUnmount
   * @param {  }
   * @infos "https://reactjs.org"
   */
  public componentWillUnmount() {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({
      errorserver: false,
      loading: false,
    }));

    SetInterval.clear("event");
    SetInterval.clear("bip-incident");
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name render
   * @description : il est appelée. Pour le rendu ,
   * Ici le DOM virtuel fusionne avec le DOM réel
   * @param {  }
   * @infos "https://reactjs.org"
   */
  public render() {
    {
      /** Persistance de la possition du menu */
    }
    Utils.persistentColumnPosition();
    {
      /** */
    }

    return (
      <Component
        {...this.state}
        {...this.props}
        // nouvelle pagination
        onUpdateCurrentPageNumber={this.onUpdateCurrentPageNumber}
        // itemPerRow
        onChangeItemPerRow={this.onChangeItemPerRow}
        // onglet active
        onClickOnglet={this.onClickOnglet}
        // scrollIncident
        onUpdateScrollTop={this.onUpdateScrollTop}
        //
        onDeleteFakeIncident={this.onDeleteFakeIncident}
        onQualified={this.onQualified}
        onSubmitPatterns={this.onSubmitPatterns}
        onChangePatterns={this.onChangePatterns}
        onSearchValue={this.onSearchValue}
        onSubmitSeaPatterns={this.onSubmitSeaPatterns}
        onCloseSeaPatterns={this.onCloseSeaPatterns}
        onClosePattern={this.onClosePattern}
        rediRectToo={this.rediRectToo}
      />
    );
  }
}
/**
 * @function
 * @name mapStateToProps
 * @description : mapStateToProps prend
 * un composant en entrée et retourne le même composant avec de props
 * @param { any } state
 * @infos "https://react-redux.js.org/using-react-redux/connect-mapstate"
 */
export function mapStateToProps(state: any) {
  {
    /** nouveaux props */
  }
  let incidentTypes: any;
  if (state.IncidentTypesLoaded.data) {
    incidentTypes = [...state.IncidentTypesLoaded.data];
    incidentTypes.push({
      id: -1,
      label: "NO_INCIDENT",
      labelFr: "NO_INCIDENT",
      orderView: 1,
    });
    incidentTypes.push({
      id: -2,
      label: "ER_CAMERA",
      labelFr: "ER_CAMERA",
      orderView: 2,
    });
  }
  return {
    checkIncidents: state.CheckNewIncidents.data,
    // checkIncidentisnotqualify: state.CheckIncidentsIsNotQualify.data,
    data: state.TunnelWatchCameraLoaded.data,
    dataiSQualified: state.ImpactIsQualified.data,
    error: state.TunnelWatchCameraLoaded.error,
    itemslabelIncident: incidentTypes,
    loading: state.TunnelWatchCameraLoaded.loading,
  };
}
{
  /** exporter le HOC : connect */
}
export default connect(mapStateToProps, {
  TunnelIncidentLoadedActionCreator,
  CheckNewIncidentsActionCreator,
  ImpactIsReQualifiedActionCreator,
  ImpactIsQualifiedActionCreator,
  ImpactFakeDeletedActionCreator,
  IncidentTypesLoadedActionCreator,
})(Container);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/incidents/home/container.tsx